import { defineDirective, handleApiError, IOmniaShell, IUibModalScope, shell } from "../../../omnia"
import { INutritionTemplate, INutritionTemplateApp, IPlanTemplateService, ProductAppInput } from "../../../types"
import { ProductApplicationVm } from "../products/productApplicationVm"

export class TemplateEditPopupCtrl extends shell.Dialog {

    static create(): ng.IDirective {

        return defineDirective(TemplateEditPopupCtrl, "app/nutrition/plan/edit/template/template-edit.html", {});

    }

    static $inject = ["$scope", "OmniaNutritionPlanTemplateService", "OmniaShell"];

    private editingTemplate: INutritionTemplate;
    private applications: NutritionTemplateAppVm[];

    constructor($scope: ng.IScope, private svc: IPlanTemplateService, shell: IOmniaShell) {

        super($scope, shell);
        this.$scope = <IUibModalScope>$scope.$parent;

        let session = shell.getSession();

        var products = <ProductApplicationVm[]>this.arguments;

        this.applications = products.map(p => new NutritionTemplateAppVm(p, session.yearId));

        this.editingTemplate = <INutritionTemplate>{
            UserId: session.currentUser.Id,
            Name: getDefaultName(products),
            Applications: []
        };
    }

    private cancelEdit() {
        this.cancel();
    }

    private canCommitEdit(): boolean {
        return !!this.editingTemplate.Name;
    }

    get hasCompletedApp(): boolean {
        return this.applications.filter(a => a.hasBeenCompleted).length > 0;
    }

    get hasCompletedApps(): boolean {
        return this.applications.filter(a => a.hasBeenCompleted).length > 1;
    }

    commitEdit() {

        this.editingTemplate.Applications = this.applications.map(a => a.getApplication());

        this.svc.saveTemplate(this.editingTemplate)
            .then(r => this.close(true))
            .catch(e => handleApiError(this.shell, e))


    }
}

export class NutritionTemplateAppVm {

    public hasBeenCompleted: boolean;
    public complete: boolean;
    public nutritionTemplateApp: INutritionTemplateApp;

    constructor(private product: ProductApplicationVm, private yearId: number) {

        const app = product.productApp

        this.nutritionTemplateApp = <INutritionTemplateApp>{
            FertiliserProductId: app.Fertiliser.StandardProductId,
            Rate: app.LastInputUsed === ProductAppInput.ProductRate
                ? app.ProductRate
                : app.LastInputUsed === ProductAppInput.NutrientRate
                    ? app.NutrientRate
                    : app.NutrientPct,
            ProductAppInput: app.LastInputUsed,
            ApplicationDate: this.getTemplateDate(app.ApplicationDate),
            TargetNutrient: app.TargetNutrient,
            GrowthStage: app.GrowthStage,
            Complete: app.AutoComplete
        };

        this.hasBeenCompleted = this.nutritionTemplateApp.Complete;
        this.complete = this.hasBeenCompleted;
    }

    get name(): string {
        return this.product.productApp.Fertiliser.Name;
    }

    public getApplication(): INutritionTemplateApp {
        this.nutritionTemplateApp.Complete = this.complete;
        return this.nutritionTemplateApp;
    }

    private getTemplateDate(date: Date) {
        return new Date(date.getFullYear() === this.yearId ? 2012 : 2011, date.getMonth(), date.getDate());
    }
}

function getDefaultName(apps: ProductApplicationVm[]) {

    let name = apps.map(f => f.productApp.Fertiliser.StandardProduct.Name).join(" + ")

    if (name.length > 100) {
        name = name.substring(0, 100).replace(/[\s\+]+$/, "")
    }

    return name

}
